<div *ngIf="!backbtnflag">
  <div class="content-wrapper">
    <div class="container-fluid">

      <div class="row" *ngIf="displaybtn">
        <div class="col-md-12">
          <div class="filter-section">
            <button mat-flat-button color="warn" class="btn-warn" (click)='navigateToItemDetails(true)'>
              <span>{{'questions.btnBack' | translate}}</span>
            </button>
            <ng-container>
              <div class="question-label">
                <div class="col-md-3">
                  <label>{{'questions.label' | translate}}</label>
                </div>
                <div class="col-md-9" *ngIf="radioButtons">
                  <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" [(ngModel)]="selectedOption">
                    <mat-radio-button class="QTypeoption-group" value="1" selected *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree)">{{'questions.radio.label1' | translate}}</mat-radio-button>
                    <mat-radio-button  class="QTypeoption-group" value="2" *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree)" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)">{{'questions.radio.label2' | translate}}</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
      <div class="row" *ngIf="flag1 && flag && flag2 && flag3 && flag4 && flag5
        && flag6 && flag7 &&flag8 && flag9 && flag10 && flag11 && flag12 && flag13 && flag14">
        <div class="col-md-3">
          <div class="btn-selection" (click)="gotoMultipleChoice()" *ngIf="evaluationMode == 2 || (evaluationMode == 1 && scoringTypeId == ScoringTypeEnum.OnOption)"><button [ngClass]="{'active1': tab=='tab1'}">{{this.QuestionTypes.items[0].queTypeDescription}}</button></div>
          <div class="btn-selection"><button (click)="gotFillinthBlank()" *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree) && evaluationMode == 2" [ngClass]="{'active1': tab=='tab2'}" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)"> {{this.QuestionTypes.items[1].queTypeDescription}}</button></div>
          <div class="btn-selection"><button (click)="gotoDiscriptive()" *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree) && evaluationMode == 2" [ngClass]="{'active1': tab==='tab6'}" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)">{{this.QuestionTypes.items[3].queTypeDescription}}</button></div>
          <div class="btn-selection" (click)="gotoMatrix()"><button *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree && evaluationMode == 2 || (evaluationMode == 1 && scoringTypeId == ScoringTypeEnum.OnOption)" [ngClass]="{'active1': tab=='tab7'}" [disabled]="(scoringTypeId == ScoringTypeEnum.On180360Degree)">{{this.QuestionTypes.items[6].queTypeDescription}}
            </button></div>
          <div class="btn-selection">
            <button (click)="gotoSurvey()" *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree)" [ngClass]="{'active1':
              tab==='tab8'}" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)">{{this.QuestionTypes.items[4].queTypeDescription}}</button>
          </div>

          <div class="btn-selection"><button (click)="gotoMatchandOrders()" [ngClass]="{'active1': tab==='tab3'}" *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree) && evaluationMode == 2" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)">{{this.QuestionTypes.items[2].queTypeDescription}}</button></div>
          <div class="btn-selection"><button (click)="gotoHotspot()"  *ngIf="(scoringTypeId != ScoringTypeEnum.OnOption && scoringTypeId != ScoringTypeEnum.On180360Degree) && evaluationMode == 2" [ngClass]="{'active1': tab==='tab9'}" [disabled]="(scoringTypeId == ScoringTypeEnum.OnOption || scoringTypeId == ScoringTypeEnum.On180360Degree)">{{this.QuestionTypes.items[10].queTypeDescription}}</button></div>
          <!-- <div class="btn-selection"><button (click)="gotoFreeText()" [ngClass]="{'active1': tab==='tab4'}" disabled>Free
              Text</button></div>
          <div class="btn-selection"><button (click)="gotoHotSpot()" [ngClass]="{'active1': tab==='tab5'}" disabled>Hot
              Spot</button></div> -->
        </div>

        <div class="col-md-9">
          <div class="flex-container" *ngIf="setHotspot" >
            <div class="main-block" (click)="navigateToHotspot()">
              <div class="selection-heading"><span>{{this.QuestionTypes.items[10].queTypeDescription}} - {{this.QuestionTypes.items[10].subTypes[0].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <label class="question-block-label">{{'questions.hotspotquestiontype.singleChoice.question' | translate}}</label>
                <img src="../../../assets/single_choice.png" style="width: 100%;">
              </div>
            </div>

            <div class="main-block" (click)="navigateToHotspotmultiChoice()">
              <div class="selection-heading"><span>{{this.QuestionTypes.items[10].queTypeDescription}} - {{this.QuestionTypes.items[10].subTypes[1].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <label class="question-block-label">{{'questions.hotspotquestiontype.multiChoice.question' | translate}}</label>
                <img src="../../../assets/multi-response.png" style="width: 100%;">
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9">
          <div class="flex-container" *ngIf="setMatchAndOrder && evaluationMode == 2">
            <div class="main-block" (click)="navigateMatchOrder()">
              <div class="selection-heading"><span>{{this.QuestionTypes.items[2].queTypeDescription}} - {{this.QuestionTypes.items[2].subTypes[0].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <label id="example-radio-group-label" class="question-block-label">{{'questions.matchAndOrder.choice1.question' | translate}}</label>
              </div>
              <div class="question-type-span">
                <div class="question-span">
                  <span class="span">{{'questions.matchAndOrder.choice1.radio.option1' | translate}}</span>
                  <div class="line"></div>
                  <span class="span"></span>
                </div>
                <div class="question-span">
                  <span class="span">{{'questions.matchAndOrder.choice1.radio.option2' | translate}}</span>
                  <div class="line"></div>
                  <span class="span"></span>
                </div>
                <div class="question-span">
                  <span class="span">{{'questions.matchAndOrder.choice1.radio.option3' | translate}}</span>
                  <div class="line"></div>
                  <span class="span"></span>
                </div>
              </div>
              <div class="question-type-button">
                <button class="button">{{'questions.matchAndOrder.choice1.buttons.btn1' | translate}}</button>
                <button class="button">{{'questions.matchAndOrder.choice1.buttons.btn2' | translate}}</button>
                <button class="button">{{'questions.matchAndOrder.choice1.buttons.btn3' | translate}}</button>
              </div>
            </div>
            <!-- <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group">
              <mat-radio-button class="option-button" [value]="i" [checked]="i === 2" readonly>
                <span></span>
              </mat-radio-button>
            </mat-radio-group> -->
          </div>
        </div>

        <!-- mcq -->
        <div class="col-md-9">
          <div class="flex-container" *ngIf="setQuestionOption==true && evaluationMode == 2 || (evaluationMode == 1 && scoringTypeId == ScoringTypeEnum.OnOption && setQuestionOption==true)">
            <div class="main-block" (click)='navigateToAddQuestionsTyperadio()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[0].queTypeDescription}} - {{this.mcqSubType[0].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.multipleChoice.choice1.question' | translate}}</label>
                <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" *ngFor="let country of countries; let i=
                  index">
                  <mat-radio-button class="option-button" [value]="i" [checked]="i === 2" readonly>
                    <span>{{country}}</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="main-block" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree" (click)='navigateToAddQuestionsTypecheckbox()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[0].queTypeDescription}} - {{this.mcqSubType[1].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.multipleChoice.choice2.question' | translate}}</label>
                <div class="option-group">
                  <mat-checkbox class="option-button" value="1" [checked]="true" readonly><span>Australia</span>
                  </mat-checkbox>
                  <mat-checkbox class="option-button" value="2" readonly><span>Austria</span></mat-checkbox>
                  <mat-checkbox class="option-button" value="3" [checked]="true" readonly><span>Europe</span>
                  </mat-checkbox>
                  <mat-checkbox class="option-button" value="4" [checked]="true" readonly><span>Asia</span>
                  </mat-checkbox>
                </div>
              </div>
            </div>
            <div class="main-block" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree" (click)='navigateToAddQuestionsTypeTruFalse()'>
              <div class="selection-heading">
                <span>{{this.QuestionTypes.items[0].queTypeDescription}} - {{this.mcqSubType[2].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.multipleChoice.choice3.question' | translate}}</label>
                <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" *ngFor="let o of yesOrNo; let i= index">
                  <mat-radio-button class="option-button" value="i" [checked]="i
                    === 0" readonly><span>{{o}}</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9">
          <div class="flex-container" *ngIf="setMatrix==true && evaluationMode == 2 || (evaluationMode == 1 && scoringTypeId == ScoringTypeEnum.OnOption && setMatrix==true)">
            <div class="matrix-table-block" (click)='navigateToAddQuestionsMatrix()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[6].queTypeDescription}} - {{this.QuestionTypes.items[6].subTypes[0].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label" class="matrix-label">{{'questions.matrix.choice1.question' | translate}}</label><br>
                <div class="horizontal-view-truefalse">
                  <mat-radio-group name="radioButtons">
                    <table class="metrix-table">
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center" *ngFor="let o of options">
                          <div class="editor">
                            <app-preview-option-editor [optionValue]="o"></app-preview-option-editor>
                          </div>
                        </th>
                      </tr>
                      <tr *ngFor="let o of questions">
                        <td>
                          <p>{{o}}</p>
                        </td>
                        <td class="text-center" *ngFor="let o of questions">
                          <mat-radio-button class="question-mat-radio" [checked]='false' [value]="false">
                          </mat-radio-button>
                        </td>
                      </tr>
                    </table>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <div class="flex-container" *ngIf="setFillinthBlank==true && evaluationMode == 2">
            <div class="main-block " (click)="navigateToFillInTheBlank()">
              <div class="selection-heading"><span>{{this.QuestionTypes.items[1].queTypeDescription}} - {{this.QuestionTypes.items[1].subTypes[2].queSubtypeDescription}}</span></div>
              <div class="question-block blank-box-size">
                <div class="block-layer"></div>
                <label id="example-radio-group-label"><input type="text" class="input-fill">{{'questions.fillInTheBlanks.choice1.question' | translate}}</label>
              </div>
            </div>
            <!-- <div class="main-block">
              <div class="selection-heading"><span>Fill in the Blanks - Dropdown
                </span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">
                  <select class="input-fill">
                    <option>Coffee</option>
                    <option selected>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</option>
                  </select> of the following are continents?</label>
              </div>
            </div> -->
          </div>
        </div>

        <div class="col-md-9">
          <div class="flex-container" *ngIf="setSurvey==true">
            <div class="main-block" (click)='navigateToAddSurveyTyperadio()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[0].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice1.question' | translate}}</label>
                <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" *ngFor="let Option of Options; let i=
                  index">
                  <mat-radio-button class="option-button" [value]="i" [checked]="i === 0" readonly>
                    <span>{{Option}}</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="main-block" (click)='navigateToAddSurveyMultiTyperadio()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[1].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice2.question' | translate}}</label>
                <div class="option-group">
                  <mat-checkbox class="option-button" value="1" [checked]="true" readonly><span>
                    {{'questions.survey.choice2.checkbox.option1' | translate}}</span>
                  </mat-checkbox>
                  <mat-checkbox class="option-button" value="2" readonly><span>{{'questions.survey.choice2.checkbox.option2' | translate}}</span></mat-checkbox>
                  <mat-checkbox class="option-button" value="3" [checked]="true" readonly><span>{{'questions.survey.choice2.checkbox.option3' | translate}}</span>
                  </mat-checkbox>
                  <mat-checkbox class="option-button" value="4" [checked]="true" readonly><span>{{'questions.survey.choice2.checkbox.option4' | translate}}</span>
                  </mat-checkbox>
                </div>
              </div>
            </div>
            <div class="main-block" (click)='navigateToAddshortanswar()'>
              <div class="selection-heading">
                <span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[2].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice3.question' | translate}}</label>
                <div class="border-t">
                  {{'questions.survey.choice3.placeholderAns' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="flex-container" *ngIf="setSurvey==true">
            <div class="main-block" (click)='navigateToSurveyLikedislike()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[3].queSubtypeDescription}}</span></div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice4.question' | translate}}</label>
                <div class="thumbs">
                  <span class="stars"><mat-icon>thumb_up</mat-icon></span>
                  <span class="stars"><mat-icon>thumb_down</mat-icon></span>
                </div>
              </div>
            </div>
            <div class="main-block" (click)='navigateToSurveyStarRating()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[4].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice5.question' | translate}}</label>
                <div class="stars-block">
                  <span class="stars"><mat-icon>star_border</mat-icon></span>
                  <span class="stars"><mat-icon>star_border</mat-icon></span>
                  <span class="stars"><mat-icon>star_border</mat-icon></span>
                  <span class="stars"><mat-icon>star_border</mat-icon></span>
                  <span class="stars"><mat-icon>star_border</mat-icon></span>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <span>{{'questions.survey.choice5.labelNotImp' | translate}}</span>
                  <span>{{'questions.survey.choice5.labelImp' | translate}}</span>
                </div>
              </div>
            </div>
            <div class="main-block" (click)='navigateToSurveyNumberRating()'>
              <div class="selection-heading">
                <span>{{this.QuestionTypes.items[4].queTypeDescription}} - {{surveySubTypes[5].queSubtypeDescription}}</span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.survey.choice6.question' | translate}}</label>
                <div class="radio-container">
                  <div class="form-check form-check-inline radio-options">
                    <span style="margin-bottom: -10px;">1</span>
                    <input type="radio" name="exampleRadios" id="exampleRadios1" value="a" checked>
                  </div>

                  <div class="form-check form-check-inline radio-options">
                    <span style="margin-bottom: -10px;">2</span>
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="a">
                  </div>

                  <div class="form-check form-check-inline radio-options">
                    <span style="margin-bottom: -10px;">3</span>
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="a">
                  </div>

                  <div class="form-check form-check-inline radio-options">
                    <span style="margin-bottom: -10px;">4</span>
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="a">
                  </div>

                  <div class="form-check form-check-inline radio-options">
                    <span style="margin-bottom: -10px;">5</span>
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="a">
                  </div>
                </div>
                <div style="display: flex; justify-content:
                  space-between;padding-left: 10px;">
                  <span>{{'questions.survey.choice6.labelTotally' | translate}}
                    <br>{{'questions.survey.choice6.labelSatisfied' | translate}}
                  </span>
                  <span>{{'questions.survey.choice6.labelTotally' | translate}}
                    <br>{{'questions.survey.choice6.labelDisSatisfied' | translate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <div class="flex-container" *ngIf="setDescriptive==true && evaluationMode == 2">

            <div class="main-block" (click)='navigateDescriptive()'>
              <div class="selection-heading"><span>{{this.QuestionTypes.items[3].queTypeDescription}} - {{this.QuestionTypes.items[3].subTypes[2].queSubtypeDescription}}
                </span>
              </div>
              <div class="question-block">
                <div class="block-layer"></div>
                <label id="example-radio-group-label">{{'questions.descriptive.choice1.question' | translate}}</label>
                <div class="border-t2">
                  <div class="img-d">
                    <!-- <img src="./../../../assets/descriptive-p.png" height="auto" alt=""> -->
                    <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar">
                    </ngx-editor-menu>
                    <ngx-editor placeholder="{{'questions.descriptive.choice1.placeholderAns' | translate}}" class="form-control" [editor]="editor1">
                  </ngx-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-question-list *ngIf="backbtnflag"></app-question-list>
<app-items-fill-in-the-blank-text *ngIf="!flag3 && selectedOption == '1'"></app-items-fill-in-the-blank-text>
<app-items-descriptive-plain-text *ngIf="!flag4 && selectedOption == '1'"></app-items-descriptive-plain-text>
<app-items-matrix-single-choice *ngIf="!flag5 && selectedOption == '1'"></app-items-matrix-single-choice>
<app-items-match-order-match-list *ngIf="!flag12 && selectedOption == '1'"></app-items-match-order-match-list>

<app-items-survey-number-rating *ngIf="!flag11 && selectedOption == '1'"></app-items-survey-number-rating>
<app-items-survey-short-answer *ngIf="!flag9 && selectedOption == '1'"></app-items-survey-short-answer>
<app-items-multiple-choice-multiple-response *ngIf="!flag1 && selectedOption == '1'"></app-items-multiple-choice-multiple-response>
<app-items-multiple-choice-true-or-false *ngIf="!flag2 && selectedOption == '1'"></app-items-multiple-choice-true-or-false>
<app-items-multiple-choice-single-response *ngIf="!flag && selectedOption == '1'"></app-items-multiple-choice-single-response>
<app-items-survey-single-choice *ngIf="!flag7 && selectedOption == '1'"></app-items-survey-single-choice>
<app-items-survey-multi-response *ngIf="!flag8 && selectedOption == '1'"></app-items-survey-multi-response>
<app-items-survey-like-dislike *ngIf="!flag6 && selectedOption == '1'"></app-items-survey-like-dislike>
<app-items-survey-star-rating *ngIf="!flag10 && selectedOption == '1'"></app-items-survey-star-rating>
<app-items-hotspot-question *ngIf="!flag13 && selectedOption == '1'"></app-items-hotspot-question>
<app-items-hotspot-multi-choice *ngIf="!flag14 && selectedOption == '1'"></app-items-hotspot-multi-choice>

<app-ai-generated-questions *ngIf="AIQue && selectedOption == '2'"
  [questionTypeName]="questionTypeName" [questionType]="questionType" [questionSubTypeId]="questionSubTypeId"></app-ai-generated-questions>
